<div class="wiki-item-detail__container">
  <div class="wiki-item-detail__header">
    <button class="wiki-item-detail__close-button" type="button" (click)="onCancel()">
      <div class="wiki-item-detail__close-button-container">
        <oph-icon name="chevron-down-brown" [size]="14"></oph-icon> <span>Close</span>
      </div>
    </button>

    <div class="wiki-item-detail__action-button-container">
      @if (postHasId()) {
        <list-view-menu [options]="menuOptions" (action)="onMenuOption($event)" />
      }
      <oph-button [disabled]="isLoading" class="wiki-item-detail__action-button" (buttonClick)="onSave()" color="green">
        {{ postHasId() ? 'Update' : 'Create' }}
      </oph-button>
    </div>
  </div>

  <div class="wiki-item-detail__title-container">
    <oph-input
      class="wiki-item-detail__title-input"
      [inputType]="'text'"
      [control]="$any(itemFG?.get('title'))"
      placeholder="Post title"
      [height]="56"
      [ngClass]="{'wiki-item-detail__title-input--error': itemFG?.get('title').touched && itemFG?.get('title').errors}"
      [fontSize]="22"
    ></oph-input>
    @if (itemFG?.get('title').touched && itemFG?.get('title').errors?.required) {
      <oph-error>The title is required</oph-error>
    }
  </div>

  <div class="wiki-item-detail__editor-container">
    <oph-quill-editor
      [bounds]="'.editor-container'"
      [placeholder]="'Write your content here...'"
      [quillConfig]="quillConfig"
      [inputFC]="$any(itemFG?.get('content'))"
      [quillStyles]="quillStyles"
    />
  </div>
</div>
